import { DocumentFilterCategory } from '@training/models/document/document-filter.model';

export class PropertyBag {
  public isBat: boolean = null;
  public showPopupWarning: boolean = null;
  public docFiltersDictionnary: DocFiltersDictionnary = null;
}

export class DocFiltersDictionnary {
  public dico: { [key: string]: DocumentFilterCategory[] } = {};
}
